module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/family_kid-b5ef41ab4d54f0adc53579e2d77e2f45.webp";